import { useCallback } from "react";

import { type TaskResponse } from "@vega-api/generated/types/taskResponse";
import { type Tile } from "@vega-modules/scenes/CoInvestmentsLP/components/Welcome/WelcomeStepsTiles";

import { useSubmitTask } from "../useSubmitTask";

import { WelcomeStepView } from "./WelcomeStepView";

type Props = {
  onNextStep: VoidFunction;
  task: TaskResponse;
  heading?: string;
  description?: string;
  tiles?: Tile[];
};

export const WelcomeStep = ({
  onNextStep,
  task,
  heading,
  description,
  tiles,
}: Props) => {
  const { submitTask, isPending } = useSubmitTask();

  const handleSubmit = useCallback(() => {
    submitTask(
      {
        taskId: task.id!,
        data: {
          hasAccepted: true,
        },
      },
      {
        onSuccess: () => {
          onNextStep();
        },
      },
    );
  }, [onNextStep, submitTask, task.id]);

  return (
    <WelcomeStepView
      description={description}
      heading={heading}
      isSubmitting={isPending}
      onSubmit={handleSubmit}
      tiles={tiles}
    />
  );
};
